import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminAuthenticated } from '../utils/adminAuth';

interface ProtectedAdminRouteProps {
	children: React.ReactNode;
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
	if (!isAdminAuthenticated()) {
		return <Navigate to="/admin/login" replace />;
	}

	return <>{children}</>;
}

